import { inject, Injectable } from '@angular/core';
import { CfDialogService } from '@cf/shared/dialog';
import { ConnectIcloudDialogComponent } from '../components/connect-icloud/connect-icloud-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ICloudConnectService {
  #dialog = inject(CfDialogService);

  connect() {
    return this.#dialog.open({
      content: ConnectIcloudDialogComponent,
      panelClasses: ['tw:sm:!max-w-[586px]'],
      modal: true,
    });
  }
}
